/**
 * Copyright (c) Mayoral Moda Infantil, S.A.U. and affiliates.
 */

import logger from '@utils/logger';

import publicConfig from './public';
import serverConfig from './server';

import { AppConfig } from '@/types/app-config';

const resolveConfig = (): AppConfig => {
  // Check if we are on the browser and if so, only return the public config.
  if (typeof window !== 'undefined') {
    return { server: {}, public: publicConfig };
  }

  const environment = process.env.ENVIRONMENT;
  if (environment in serverConfig) {
    const config = { server: serverConfig[environment], public: publicConfig };
    if (process.env.NODE_ENV === 'production' && process.env.BUILD !== 'true') {
      logger.info({ config }, 'Loaded production configuration');
    }
    return config;
  } else {
    throw new Error(`Unable to resolve runtime configuration for environment ${environment}`);
  }
};

const config = resolveConfig();

export default config;
